import styled from 'styled-components';
import Heading from 'styles/typography/Heading';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const RankingContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
`;

export const RankingWrapper = styled.div<{ theme: Theme }>`
  flex-direction: column;
  display: flex;
  padding: 16px 16px 62px 16px;
  position: relative;
  width: 232px;

  .next-img {
    width: 100%!important;
  }

  .title {
    ${getBodyStyle('graphikCond', { default: 'large' }, 'semiBold')};
    text-align: left;
    text-decoration: none;
    &:hover {
      color: ${getColor('textLink')};
    }
  }

  @media (${breakpoint.mdMin}) {
    width: auto;
    padding: 0 12px 62px 12px;
  }

  @media(${breakpoint.lgMin}) {
    &:last-of-type{
      padding-right: 12px;
    }
  }

`;

export const Description = styled.p<{ theme: Theme }>`
 ${getBodyStyle('graphikCompact', { default: 'small' })};
  margin: 24px 0 16px 0;
  text-align: left;
`;

export const BottomSection = styled.div`
  position: absolute;
  bottom: 0;
  margin-top: 16px;
  width: 100%;
  padding-right: 32px;

  @media(${breakpoint.mdMin}) {
    padding-right: 24px;
  }
`;

export const RankingSection = styled.div<{ theme: Theme }>`
  width: 100%;
  display: grid;
  overflow: scroll;
  margin-bottom: 48px;
  grid-template-columns: repeat(5, 1fr);

  @media (${breakpoint.mdMin}) {
    row-gap: 12px;
    overflow: hidden;

    grid-template-columns: repeat(6, 1fr);

    & > * {
    grid-column: span 2;
    }

    & > :nth-child(4),
    & > :nth-child(5) {
      grid-column: span 3;
    }
  }

  @media (${breakpoint.lgMin}) {
    overflow: hidden;
    grid-template-columns: repeat(5, 1fr); 
    & > * {
      grid-column: span 1;
    }

    & > :nth-child(4),
    & > :nth-child(5) {
      grid-column: span 1; 
    }
  }


  .title {
    margin-top: 16px;
    font-weight: 600;
    text-align: left;
    text-decoration: none;
    &:hover {
      color: ${getColor('textLink')};
    }
  }

  p {
    margin-top: 8px;
  }


  .black-button {
    width: 100%;
    height: 48px;
    text-transform: uppercase;
  }

`;

export const Title = styled(Heading)`
  margin: 24px 16px 40px 16px;
  
  @media (${breakpoint.mdMin}) {
    margin: 32px 0 48px 0;
  }
  @media (${breakpoint.lgMin}) {
    margin: 48px 0 64px 0;
  }
`;

export const TitleWrapper = styled.div`
    margin-left: 16px;
`;
